import DataTable, { createTheme } from "react-data-table-component";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import "../../pages/Home.css";
// import { useMyContext } from "../../MyContext";
import { fetchSecure, getUniqueObjects } from "./utils";
import { Tooltip } from "@mui/material";
//Components
import UploadFileNew from "../UploadFileNew";
//import CreateEdit from "./CreateEdit";
import CreateEditNew from "./CreateEditNew";
//import DisplayDetails from "./DisplayDetails";
import DisplayDetailsNew from "./DisplayDetailsNew";
import UploadFileForImport from "../UploadFileForImport";
import SuperAppButton from "../SuperAppButton";
import { FaPlus } from "react-icons/fa";
import { IoMdRefresh } from "react-icons/io";
import { MdDelete } from "react-icons/md";
// import { FaFileExport } from "react-icons/fa6";
import { LuImport } from "react-icons/lu";
import { RiCloseLargeLine } from "react-icons/ri";
import { isMobile } from "react-device-detect"; /* KAD added this Mar 17, 2025 to move the FilterField on Mobile */
import { Spinner } from "react-bootstrap"; // Added Spinner import

/* MORE SUPERTABLE code */
const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled(SuperAppButton)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;
/* KAD added this for Config Editor use case Feb 12, 2025 */
function canExportRows(props, config) {
  if (props.dontPersistData) return false;
  if (
    /* KAD added March 26, 2025 to make it possible to hide export and import buttons */
    config.security &&
    config.security.export &&
    config.security.export.indexOf("None") >= 0
  )
    return false;
  return true;
}
/* KAD added this for Config Editor use case Feb 12, 2025 */
function canImportRows(props, config) {
  if (props.dontPersistData) return false;
  if (
    /* KAD added March 26, 2025 to make it possible to hide export and import buttons */
    config.security &&
    config.security.import &&
    config.security.import.indexOf("None") >= 0
  )
    return false;
  return true;
}
function canCreate(props, config) {
  if (
    props.userDeep &&
    props.userDeep.roles &&
    props.userDeep.roles.toLowerCase().indexOf("create") >= 0
  )
    return true;

  if (
    config.security &&
    config.security.create &&
    config.security.create.indexOf("AllUsers") >= 0
  )
    return true;

  return false;
}
/*
function isSystemAdmin(props) {
  if (
    props.userDeep &&
    props.userDeep.roles &&
    props.userDeep.roles.toLowerCase().indexOf("system_admin") >= 0
  )
    return true;
  return false;
}
function canView() {}
*/

/* KAD added this Feb 12, 2025 to handle the Config Editor use case */
function canRefresh(props, config) {
  if (props.dontPersistData) return false;
  if (
    /* KAD added March 28, 2025 to make it possible to hide refresh buttons */
    config.security &&
    config.security.refresh &&
    config.security.refresh.indexOf("None") >= 0
  )
    return false;
  return true;
}

function canDeleteRows(props, config) {
  if (
    config.security &&
    config.security.delete &&
    config.security.delete.indexOf("None") >= 0
  )
    /* KAD added Oct 7, 2024 to override personal flags */
    return false;

  if (
    props.userDeep &&
    props.userDeep.roles &&
    props.userDeep.roles.toLowerCase().indexOf("delete") >= 0
  )
    return true;

  if (
    config.security &&
    config.security.delete &&
    config.security.delete.indexOf("AllUsers") >= 0
  )
    return true;

  return false;
}

/*
      <Tooltip placement='top' title='Created'>
      </Tooltip>
          data-toggle2='custom-tooltip'
          custom-title2='Create'
          data-toggle2='custom-tooltip'
          custom-title2='Refresh'>
          data-toggle2='custom-tooltip'
          custom-title2='Delete'>
          data-toggle2='custom-tooltip'
          custom-title2='Export'>
            data-toggle2='custom-tooltip'
            custom-title2='Import'>
*/
/*
 * Vik (Jan 22, 2026): Export component renders only action buttons (Plus, Refresh, Delete, Export, Import).
 * FilterComponent was removed from here to fix duplicate filter box issue.
 * The filter is now rendered only via DataTable's subHeaderComponent prop.
 */
const Export = ({
  displayState,
  props,
  config,
  onExport,
  onImport,
  refresh,
  createRecord,
  deleteRows,
  selectedRows,
}) => (
  <>
    <div style={{ display: "flex", justifyContent: "flex-start" }}>
      {displayState === "TABLE" && canCreate(props, config) && (
        <SuperAppButton
          onClick={(e) => createRecord()}
          className="filter-icon-btn"
          hover_tool_tip="Create"
        >
          <FaPlus />
        </SuperAppButton>
      )}{" "}
      {/* KAD added canRefresh for the ConfigEditor 2/12/2025 */}
      {props.depth === 1 && canRefresh(props, config) && (
        <SuperAppButton
          onClick={(e) => refresh()}
          className="filter-icon-btn"
          hover_tool_tip="Refresh"
        >
          <IoMdRefresh />
        </SuperAppButton>
      )}{" "}
      {displayState === "TABLE" && canDeleteRows(props, config) && (
        <SuperAppButton
          onClick={(e) =>
            window.confirm("Are you sure you wish to delete these objects?") &&
            deleteRows(selectedRows)
          }
          className="filter-icon-btn"
          hover_tool_tip="Delete"
        >
          <MdDelete />
        </SuperAppButton>
      )}
      {/* KAD added canExportRows for Config Editor use case Feb 12, 2025 */}
      {props.depth === 1 && canExportRows(props, config) && (
        <SuperAppButton
          onClick={(e) => onExport(e.target.value)}
          className="filter-icon-btn"
          hover_tool_tip="Export"
        >
          <LuImport />
        </SuperAppButton>
      )}
      {/* KAD added canImportRows for Config Editor use case Feb 12, 2025 */}
      {props.depth === 1 &&
        displayState === "TABLE" &&
        canCreate(props, config) &&
        canImportRows(props, config) && (
          <SuperAppButton
            onClick={(e) => onImport(e.target.value)}
            className="filter-icon-btn import"
            hover_tool_tip="Import"
          >
            <LuImport />
          </SuperAppButton>
        )}
      {props.dynamicTableButtons &&
        props.dynamicTableButtons.map((button, index) => (
          <button.component
            data={button.data}
            selectedRows={selectedRows}
            user={props.user}
            userDeep={props.userDeep}
            _key={button._key}
            label={button.label}
          />
        ))}
    </div>
    {/* Vik (Jan 22, 2026): Removed FilterComponent from here - it was causing duplicate filter boxes.
        Filter is now only rendered via DataTable's subHeaderComponent prop. */}
  </>
);

const TrackingButtons = ({ displayState, props, createRecord }) => (
  <>
    {displayState === "TRACKING_TABLE" &&
      props.userDeep &&
      props.userDeep.roles &&
      props.userDeep.roles.toLowerCase().indexOf("create") >= 0 && (
        <Tooltip placement="top" title="Create">
          <SuperAppButton
            onClick={(e) => createRecord()}
            className="filter-icon-btn"
            data-toggle2="custom-tooltip"
            custom-title2="Create"
          >
            <FaPlus />
          </SuperAppButton>
        </Tooltip>
      )}
  </>
);

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <div className="search-div input-with-icon right-icon">
    <TextField
      id="search"
      type="text"
      placeholder="Filter Results"
      value={filterText}
      onChange={onFilter}
      className="form-control"
      style={{ cursor: "text" }}
    />
    <ClearButton onClick={onClear} className="clear-btn right-icon">
      <RiCloseLargeLine />
    </ClearButton>
  </div>
);

async function exportJSONDump(object, fields, user, selectedRows) {
  var ids = "";
  selectedRows.forEach((item) => {
    var doc = { row: item };
    ids += doc.row.id + ",";
  });
  if (ids.endsWith(",")) ids = ids.substring(0, ids.length - 1);

  if (ids.length === 0) ids = "all";
  console.log(ids);

  const res = await fetchSecure(
    "api/export/" +
      object +
      "/json/" +
      JSON.stringify(fields) +
      "/" +
      user +
      "/" +
      ids,
  );
  const blob = await res.blob();
  const downloadLink = document.createElement("a");
  const objectURL = URL.createObjectURL(blob);
  downloadLink.href = objectURL;
  const timestamp = new Date().toISOString().replace(/:/g, "_");
  downloadLink.download = `export-${timestamp}.json`;
  downloadLink.style.display = "none";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  // Clean up by removing the link and revoking the object URL
  document.body.removeChild(downloadLink);
  // const link = document.createElement("a");
  // link.setAttribute(
  //   "href",
  //   "api/export/" + object + "/json/" + JSON.stringify(fields) + "/" + user
  // );
  // link.click();
  /*
    const response = await fetchSecure("/api/export/" + object + "/json/XXX/" + props.user, {
      headers: { "Content-Type": "application/json", "Authorization": "XXXX" }
      method: "get",
    });
    const data = await response.json();
   */
}
/*
function exportCSVDump(object, fields, user) {
  const link = document.createElement("a");
  link.setAttribute(
    "href",
    "api/export/" + object + "/csv/" + JSON.stringify(fields) + "/" + user
  );
  link.click();
}
  */

/* MORE SUPERTABLE code */
/* MORE SUPERTABLE code */
/* MORE SUPERTABLE code */

export default function SuperAppObject(props) {
  const { collection_name } = props;
  const [sortData /* setSortData */] = useState(
    props.config.defaultSort || { selector: "creationDate", asc: false },
  ); /* KAD removed React */
  // const globalContextData = useMyContext();
  const [showTrackingList, setShowTrackingList] = useState(false);

  const [config /* setConfig */] = useState(props.config);
  const [deepConfig /* setDeepConfig */] = useState(
    props.deepConfig,
  ); /* entire config tree..in case you need hierarchy of tabular data */
  const [selectedRows, setSelectedRows] = useState([]);
  const [, /* lastDisplayState*/ setLastDisplayState] = useState("");
  const [whereValue /* setWhereValue */] = useState(
    props.drill_where_value || "",
  );

  /* KAD modified this with props.thisObject Feb 10, 2025 to try and go directly to an Object Hashmap */
  const [formData, setFormData] = useState({
    data: props.thisObject || {},
    status: "IDLE",
  });

  /* GENERIC CODE FROM SUPERTABLE */
  const [displayState, setDisplayState] = useState(props.displayState);
  //console.log("🚀 ~ SuperAppObject ~ displayState:", displayState)
  const [activeTab, setActiveTab] =
    useState(0); /* KAD added Feb 19, 2025 to hold the active Tab */
  const [actionType, setActionType] = useState("");
  const [object /* setObject */] = useState(collection_name);
  const [, /* row */ setRow] = useState({});
  const [data, setData] = useState(props?.inputData || []);

  const [originalData, setOriginalData] = useState({});
  const [columns /* setColumns */] = useState(
    config?.table || config?.columns || [],
  );
  // const [depth, setDepth] = useState(props.depth); /* for nested objects */
  const [filterText, setFilterText] = useState(""); /* KAD removed React. */
  const [resetPaginationToggle, setResetPaginationToggle] =
    useState(false); /* KAD removed React. */
  const filteredItems =
    data?.length > 0
      ? data.filter((item) => {
          if (config.filterField) {
            //console.log("item?.[config.filterField]?",item?.[config.filterField],filterText)
            // Use the old logic if filterField is present
            return (
              item[config.filterField] &&
              typeof item[config.filterField] == "string" &&
              item?.[config.filterField]
                ?.toLowerCase()
                ?.includes(filterText.toLowerCase())
            );
          } else if (config.filterFields && config.filterFields.length > 0) {
            // Use the new logic if filterFields is present
            const filterTextLower = filterText.toLowerCase();
            for (const fieldName of config.filterFields) {
              if (
                item[fieldName] &&
                item[fieldName]?.toLowerCase()?.includes(filterTextLower)
              ) {
                return true; // Match found in at least one field
              }
            }
            return false; // No match found in any field
          } else {
            return true; // Or false, depending on your default behavior when neither is present
          }
        })
      : [];

  /* OLD CODE April 2, 2025  KAD
  const filteredItems = data
    ? data.filter(
        (item) =>
          item[config.filterField] &&
          item[config.filterField]
            .toLowerCase()
            ?.includes(filterText.toLowerCase())
      )
    : [];
*/

  /* TODO: Can't have this hardcoded to agents here */

  if (props.collection === "agents") {
    props.showAgent = true;
  }

  if ("inputData" in props) {
    // console.log("KEVIN2 data passed in " + JSON.stringify(config, null, " "));
    // console.log("KEVIN2 data passed in " + JSON.stringify(props.inputData, null, " "));
    // console.log("KEVIN2 data passed in " + JSON.stringify(data, null, " "));
    // console.log("KEVIN2 data passed in " + JSON.stringify(props, null," "));
  }

  const callbackForCancelUploadFile = async () => {
    setDisplayState("DISPLAY");
    setActionType("DISPLAY");
  };

  const callbackForCancelUploadFileForImport = async () => {
    setDisplayState("TABLE");
    setActionType("DISPLAY");
  };

  const callbackForUploadFileForImport = async (fileName) => {
    setTimeout(() => loadObjects(), 1000);
    setDisplayState("TABLE");
    setActionType("DISPLAY");
  };

  const callbackForUploadFile = async (fileNames) => {
    setDisplayState("DISPLAY");
    setActionType("DISPLAY");

    /* there are 2 copies, because I want to keep the UI in sync with the database withouth having to refresh the entire screen again */

    //var dataToSave = { attachments: [] }; ORIG CODE KAD Jan 21, 2025
    var dataToSave = {};

    if (!("attachments" in formData.data)) {
      formData.data["attachments"] = [];
    }
    /* KAD added this Jan 21, 2025 to existing attachments if any */ /* KAD took out else Feb 6, 2025 */
    dataToSave = { attachments: formData.data["attachments"] };

    for (let x = 0; x < fileNames.length; x++) {
      const fileName = fileNames[x];
      formData.data["attachments"].push({
        fileName: fileName,
        shortFileName: fileName.substring(fileName.lastIndexOf("~~") + 2),
      });
      /* This is not required because datatoSave.attachments already points to the formatData attachmets....so I only need to add in one place Jan 21, 2025 KAD 
      dataToSave["attachments"].push({
        fileName: fileName,
        shortFileName: fileName.substring(fileName.lastIndexOf("~~") + 2),
      });
*/
    }
    dataToSave["attachments"] = getUniqueObjects(
      dataToSave["attachments"],
      "fileName",
    ); /* KAD added to make sure we don't add the same File Name in the attachments array when we already loaded it JAN 31, 2025 */
    const response = await fetchSecure(
      "/api/updateObject/" +
        config.collection +
        "/" +
        formData.data["id"] +
        "/" +
        props.user,
      {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(dataToSave),
      },
    );
    const data = await response.json();

    if (data.success) {
      setTimeout(() => loadObject(formData.data["id"]), 4000);
    }
  };

  /* BEGIN TABLE FUNCTIONS */
  /* delete all the selected Rows */
  const deleteRows = (selectedRows) => {
    selectedRows.forEach((item) => {
      var doc = { row: item };
      deleteRow(doc);
    });
    /* reload after 2 seconds to make sure all the deleted Rows are done, could take a bit */
    setTimeout(() => {
      loadObjects();
      setSelectedRows([]);
    }, 2000);
  };

  /* KAD added to handle Config Editor use case Feb 12, 2025 */
  const deleteRowsDontPersist = (selectedRows) => {
    selectedRows.forEach((item) => {
      console.log("DELETE ROW: " + JSON.stringify(item));
      console.log("DELETE ROW: " + JSON.stringify(data));
      data.splice(item["id"], 1);
      console.log("DELETE ROW: " + JSON.stringify(data));
      setData(data);
    });
    if (props.submit) props.submit(null, props.config.collection, data);
  };

  /* Vik (Jan 22, 2026): Combined action buttons and filter into subHeaderComponent.
     This ensures action buttons appear on LEFT and filter on RIGHT.
     DataTable's 'actions' prop places content on the right, so we avoid it. */
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {/* Vik (Jan 22, 2026): Action buttons on the left side */}
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {displayState === "TABLE" && canCreate(props, config) && (
            <SuperAppButton
              onClick={(e) => createRecord()}
              className="filter-icon-btn"
              hover_tool_tip="Create"
            >
              <FaPlus />
            </SuperAppButton>
          )}
          {props.depth === 1 && canRefresh(props, config) && (
            <SuperAppButton
              onClick={(e) => refresh()}
              className="filter-icon-btn"
              hover_tool_tip="Refresh"
            >
              <IoMdRefresh />
            </SuperAppButton>
          )}
          {displayState === "TABLE" && canDeleteRows(props, config) && (
            <SuperAppButton
              onClick={(e) =>
                window.confirm(
                  "Are you sure you wish to delete these objects?",
                ) && deleteRows(selectedRows)
              }
              className="filter-icon-btn"
              hover_tool_tip="Delete"
            >
              <MdDelete />
            </SuperAppButton>
          )}
          {props.depth === 1 && canExportRows(props, config) && (
            <SuperAppButton
              onClick={(e) =>
                exportJSONDump(
                  config.collection,
                  config.exportFields,
                  props.user,
                  selectedRows,
                )
              }
              className="filter-icon-btn"
              hover_tool_tip="Export"
            >
              <LuImport />
            </SuperAppButton>
          )}
          {props.depth === 1 &&
            displayState === "TABLE" &&
            canCreate(props, config) &&
            canImportRows(props, config) && (
              <SuperAppButton
                onClick={(e) => uploadFileForImport(e.target.value)}
                className="filter-icon-btn import"
                hover_tool_tip="Import"
              >
                <LuImport />
              </SuperAppButton>
            )}
          {props.dynamicTableButtons &&
            props.dynamicTableButtons.map((button, index) => (
              <button.component
                key={index}
                data={button.data}
                selectedRows={selectedRows}
                user={props.user}
                userDeep={props.userDeep}
                _key={button._key}
                label={button.label}
              />
            ))}
        </div>
        {/* Vik (Jan 22, 2026): Filter on the right side */}
        {!isMobile && (
          <FilterComponent
            onFilter={(e) => setFilterText(e.target.value)}
            onClear={handleClear}
            filterText={filterText}
          />
        )}
      </div>
    );
  }, [
    filterText,
    resetPaginationToggle,
    displayState,
    props,
    config,
    selectedRows,
    data,
  ]);

  const createRecord = () => {
    const maxCount =
      "max" +
      collection_name.substring(0, 1).toUpperCase() +
      collection_name.substring(1);
    if (maxCount in props.userDeep && data.length > props.userDeep[maxCount]) {
      alert(
        "You have exceeded your maximum " +
          props.collection_name +
          " of " +
          props.userDeep[maxCount] +
          ".  Please upgrade your package to a higher level if you need more agents",
      );
    } else {
      /* Vik(May 13, 2025): Initialize formData.data with default values from config.fields */
      const initialData = {};
      (config?.fields || []).forEach((field) => {
        if (field.default !== undefined && field.default !== "") {
          initialData[field.name] = field.default;
        }
      });
      setFormData({
        data: initialData,
        status: "IDLE",
      });
      if (window && window.dataLayer)
        window.dataLayer.push({
          event: "hit_create_button_event",
          event_category: "example",
          event_action: "button_click",
          event_label: "submit_button",
          event_value: 1,
        });
      setLastDisplayState(displayState);
      setDisplayState("CREATE_EDIT");
      setActionType("CREATE");
    }
  };
  const backToBASIC = () => {
    setDisplayState("BASIC_TABLE");
    setActionType("DISPLAY");
  };

  const refresh = () => {
    loadObjects();
  };

  const handleRowClicked = (row) => {
    //console.log("handle row clicked - " + JSON.stringify(row));
    setRow(row);
    /* TODO - not sure why there are 2 things setting the Form Data..probably just some frustration in the past */
    /*
    var form = {
      data: row,
      status: "IDLE",
    };
    */
    setFormData({
      data: row,
      status: "IDLE",
    });
    setDisplayState("DISPLAY");
    setActionType("EDIT");
  };

  const handleFileClicked = async (row) => {
    //console.log("handle file clicked - " + JSON.stringify(row));
    //window.open("api/getFile/" + row.fileName);
    // KAD fixed this Dec 21, 2024
    const response = await fetchSecure("api/getFile/" + row.fileName);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      row.fileName.substring(row.fileName.lastIndexOf("~~") + 2),
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleRowClickedDisplay = (row) => {
    //console.log("handle row clicked - " + JSON.stringify(row));
    setRow(row);
    /*
    var form = {
      data: row,
      status: "IDLE",
    };
    */
    //console.log("form = " + JSON.stringify(form));
    setFormData({
      data: row,
      status: "IDLE",
    });
    setDisplayState("DISPLAY");
    setActionType("DISPLAY");
  };

  const loadObject = async (id) => {
    /*
    console.log(
      "IN loadObject - api/getObject/" + config.collection + "/" + id
    );
    */
    try {
      await fetchSecure("api/getObject/" + config.collection + "/" + id)
        .then((response) => response.json())
        .then((data) => {
          //console.log("🚀 ~ .then ~ data:sss", data);
          //console.log("data = " + JSON.stringify(data));
          data["id"] = id; // TODO this is kind of weird...certain functions in server.js put the id in the payload automatically...this one doesn't
          setFormData({
            data: data,
            status: "IDLE",
          });
        });
    } catch (e) {
      console.log(`Failed to loadObject`);
      console.log(e);
      console.log(e.stack);
    }
  };

  const loadObjects = async () => {
    var additionalCommandLineArg = "";
    if ("flags" in config && config.flags.indexOf("filter_by_user") >= 0) {
      additionalCommandLineArg = "/where/userIds/array-contains/" + props.user;
    }

    if ("remote_id" in props) {
      additionalCommandLineArg = "/" + props.remote_id;
    }

    try {
      const response = await fetchSecure(
        "api/getObjects/" + config.collection + additionalCommandLineArg,
      );

      // Check if response is OK
      if (!response.ok) {
        console.warn(
          `⚠️ API returned ${response.status} for collection "${config.collection}". Showing empty table.`,
        );
        setData([]);
        return;
      }

      // Check content type to ensure we got JSON
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        // Clone response to read text without consuming the original
        const clonedResponse = response.clone();
        const text = await clonedResponse.text();

        // Check if it's HTML (error page or marketing site)
        if (
          text.trim().startsWith("<!DOCTYPE") ||
          text.trim().startsWith("<html")
        ) {
          console.warn(
            `⚠️ API returned HTML instead of JSON for collection "${config.collection}". This usually means:`,
          );
          console.warn(
            `   - The endpoint doesn't exist or requires authentication`,
          );
          console.warn(
            `   - The collection "${config.collection}" doesn't exist in the database`,
          );
          console.warn(`   - Showing empty table for demo purposes`);
          setData([]);
          return;
        }

        // If it's not HTML but also not JSON, try to parse as text
        console.warn(
          `⚠️ Unexpected content type: ${contentType} for collection "${config.collection}"`,
        );
        setData([]);
        return;
      }

      // Parse as JSON
      const data = await response.json();

      console.log(
        `[SuperAppObject] Loaded ${
          Array.isArray(data) ? data.length : "N/A"
        } objects for ${config.collection}`,
      );
      if (Array.isArray(data) && data.length > 0) {
        console.log("[SuperAppObject] Sample Row Data:", data[0]);
        console.log("[SuperAppObject] Table Columns Config:", config.table);
        // ... selector checks ...
      }

      /* the array is at a lower level */
      //console.log("KEVIN1 " + data)

      if (!Array.isArray(data)) {
        /* KAD Jan 5, 2025  because of Token expiration sending a hashmap back instead of an array */
        setData([]);
        return;
      }

      if (typeof props.sub_array !== "undefined") {
        /* KAD taking this out to confirm that this is not needed 
        const kevin = data.map((object, index) => {
          object.config["row"] = index;
          object.config["id"] = object.id;
          object.config["creationDate"] = object.creationDate;
          object.config["updateDate"] = object.updateDate;
          object.config["user"] = object.user;
          return object.config;
        });

        setOriginalData(data);
        //console.log("KEVIN1 - " + JSON.stringify(kevin));
        setData(kevin);
        */
      } else {
        setData(data);
      }
    } catch (error) {
      console.error(
        `❌ Error loading objects from collection "${config.collection}":`,
        error,
      );
      // Set empty data so the table shows "no records" instead of crashing
      setData([]);
    }
  };

  useEffect(() => {
    //console.log("IN HERE SuperAppObject useEffect (props.id) - " + props.id);
    async function loadAgent() {
      if ("id" in props && props.id && props.id.length > 0) {
        await loadObject(props.id);
      }
    }
    loadAgent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  useEffect(() => {
    if (props?.inputData) {
      //console.log("using inputData - " + JSON.stringify(props.inputData));
      //console.log(props.inputData);
      setData(props?.inputData || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.inputData]);

  useEffect(() => {
    /*
    function handleStatusChange(status) {
      console.log("Doing handleStatusChange - " + status);
    }
      */
    //console.log("IN HERE useEFFECT");
    if (data && data.length === 0 && !("inputData" in props)) {
      //console.log("KEVIN1 getting database data " + JSON.stringify(config));
      var additionalCommandLineArg = "";
      if ("remote_id" in props)
        additionalCommandLineArg = "/" + props.remote_id;

      if ("drill_where_field" in props && "drill_where_value" in props) {
        additionalCommandLineArg =
          "/where/" +
          props.drill_where_field +
          "/==/" +
          props.drill_where_value;
      }
      if ("flags" in config && config.flags.indexOf("filter_by_user") >= 0) {
        additionalCommandLineArg =
          "/where/userIds/array-contains/" + props.user;
      }

      // Use regular fetch for demo collections (no auth required)
      const isDemoCollection =
        config.collection &&
        (config.collection.startsWith("demo_") ||
          config.collection === "demo_users" ||
          config.collection === "demo_products" ||
          config.collection === "demo_tasks");

      // Use regular fetch for demo collections, fetchSecure for others
      const url =
        "api/getObjects/" + config.collection + additionalCommandLineArg;
      let fetchPromise;
      if (isDemoCollection) {
        // Use regular fetch (no auth) for demo collections
        fetchPromise = window.fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
      } else {
        // Use fetchSecure (with auth) for other collections
        fetchPromise = fetchSecure(url);
      }

      fetchPromise
        .then(async (response) => {
          // Check content type before parsing
          const contentType = response.headers.get("content-type");
          console.log(`🔵 Response for ${config.collection}:`, {
            status: response.status,
            statusText: response.statusText,
            contentType: contentType,
            url: response.url,
            ok: response.ok,
          });

          if (!response.ok) {
            console.warn(
              `⚠️ Request failed for ${config.collection}. Status: ${response.status}`,
            );
            setData([]);
            return [];
          }

          if (!contentType || !contentType.includes("application/json")) {
            // Try to read the response text to see what we got
            const text = await response.text();
            const isHTML =
              text.trim().startsWith("<!DOCTYPE") ||
              text.trim().startsWith("<html");
            console.warn(
              `⚠️ Got non-JSON response for ${config.collection}. Status: ${response.status}, isHTML: ${isHTML}`,
            );
            if (isHTML) {
              console.warn(
                `Response preview (first 300 chars):`,
                text.substring(0, 300),
              );
              console.warn(
                `This means the route /api/getObjects/${config.collection} is not matching and falling through to the React app's catch-all route.`,
              );
            } else {
              console.warn(`Response text:`, text.substring(0, 200));
            }
            setData([]);
            return [];
          }

          // Parse as JSON
          return response.json();
        })
        .then((data) => {
          if (!data) return;
          //console.log("🚀 ~ .then ~ data:", data);
          if (!Array.isArray(data)) {
            /* KAD Jan 5, 2025  because of Token expiration sending a hashmap back instead of an array */
            setData([]);
            return;
          }

          /* TODO: Think this has to go..thie sub_array code ..not used anymore test_plans maybe??? */
          if (typeof props.sub_array !== "undefined") {
            const kevin = data.map((object, index) => {
              object.config["id"] = object.id;
              object.config["row"] = index;
              object.config["creationDate"] = object.creationDate;
              object.config["updateDate"] = object.updateDate;
              object.config["user"] = object.user;
              return object.config;
            });
            setOriginalData(data);
            setData(kevin);
          } else {
            setData(data);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      if (
        "inputData" in props &&
        props.inputData &&
        props.inputData.length > 0
      ) {
        //console.log("using inputData - " + JSON.stringify(props.inputData));
        //console.log(props.inputData);
        setData(props.inputData || []);
      }

      //if ("inputData" in props && props.inputData && props.inputData.length === 0)
      //console.log("inputData empty - " + JSON.stringify(config));
    }

    // Specify how to clean up after this effect:
    return function cleanup() {
      //console.log("Doing Cleanup");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* GENERIC CODE FROM SUPERTABLE */
  /* GENERIC CODE FROM SUPERTABLE */
  /* GENERIC CODE FROM SUPERTABLE */

  const handleSelectChange = (state) => {
    console.log("Selected Rows: ", state.selectedRows);
    console.log("Selected Rows: ", JSON.stringify(state));
    setSelectedRows(state.selectedRows);
  };

  /*
  const onColorChange = (value, name) => {
    console.log("onColorChange " + name + "," + value);
    setFormData({
      data: { ...formData.data, [name]: value },
      status: "IDLE",
    });
  };
  */

  /* delete an individual row */
  const deleteRow = (doc) => {
    // console.log("referrer", document.referrer);
    // console.log("referrer :: doc.row", doc.row);

    if (doc.row.locked === true) {
      window.confirm("Record " + doc.row.id + " not deleted.  It is locked");
      return;
    }
    /* To prevent deletion of WiX created agent from non WiX site. Vik March 21, 2025 */
    if (
      !!doc.row.wixInstanceId &&
      (!document.referrer.includes("wix.com") ||
        !document.referrer.includes("wixsite.com"))
    ) {
      window.confirm("Record " + doc.row.id + " can not be deleted.");
      return;
    }
    fetchSecure(
      "api/deleteObject/" +
        object +
        "/" +
        encodeURIComponent(doc.row.id) +
        "/" +
        props.user,
      {
        method: "GET", // or 'PUT'
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setDisplayState("TABLE");
      });
  };

  const uploadFileForImport = () => {
    setDisplayState("UPLOAD_FILE_FOR_IMPORT");
    setActionType("UPLOAD_FILE_FOR_IMPORT");
  };

  /*
  const formInvalid = () => {
    var invalid = false;
    var fieldString = "";
    config.fields.map((field) => {
      var showField = true;
      if (typeof field.conditional !== "undefined") {
        //     conditional: "AGENT_TYPE == DIALOGFLOW",
        const values = field.conditional.split(" ");
        if (formData.data[values[0]] != values[2]) showField = false;
      }
      if (
        field.required &&
        showField &&
        (!formData.data[field.name] || formData.data[field.name].length === 0)
      ) {
        console.log("Form invalid");
        fieldString += field.display_name + ", ";
        invalid = true;
      }
    });
    if (invalid) {
      setValidationString(fieldString.substring(0, fieldString.length - 2));
      return true;
    } else return false;
  };
  */

  /* get an array back from the lower depth, and save to database */
  const topLevelSave = async (field, object) => {
    //console.log("TLS = " + field);
    //console.log("TLS = " + JSON.stringify(object));
    formData.data[field] = object;
    //console.log("TLS = " + JSON.stringify(formData.data));
    if (props.depth === 1) {
      const response = await fetchSecure(
        "/api/saveObject/" + config.collection,
        {
          headers: { "Content-Type": "application/json" },
          method: "post",
          body: JSON.stringify(formData.data),
        },
      );
      const data = await response.json();
      if (data.success) {
        //console.log(data);
        setFormData({
          data: { ...formData.data },
          status: "SUCCESS",
        });
        setDisplayState("X");
        //console.log(JSON.stringify(formData));

        /* Go back and update the Tracking records */
        setTimeout(() => {
          loadObject(data.id);
        }, 1000);

        props.scrollToTop();
        setDisplayState("DISPLAY");
        setActionType("DISPLAY");
      } else {
        throw Error("Failed to add new " + field);
      }
    }
  };
  /* TODO: Think this is NOT used anymore..changed to add XX to name to see if anything breaks */
  const handleSubmitXX = async (event) => {
    try {
      const form = event.currentTarget;
      /* this will cause the Loading text to show up while waiting */
      setFormData({
        ...formData,
        status: "SUBMITTED",
      });

      /* adding another custom level of validation for objects */
      let valid = true;
      if (typeof props.validateObject !== "undefined") {
        valid = props.validateObject(formData.data);
        //console.log("valid = " + JSON.stringify(valid));
        formData.data["status"] = valid.status;
      }
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
        setFormData({
          ...formData,
          status: "VALIDATION_FAILURE",
        });
      } else {
        var dataToSave = {};
        if ("row" in formData.data && typeof props.sub_array !== "undefined") {
          /* this is an existing row when a subarray is involved  */
          const row = formData.data["row"];
          //console.log("ROW in Submit = " + row);
          originalData[row][props.sub_array] = formData.data;
          //console.log(JSON.stringify(originalData[row]));
          dataToSave = originalData[row];
        } else if (
          !("row" in formData.data) &&
          typeof props.sub_array !== "undefined"
        ) {
          /* this is a new row when a subarray is involved */
          dataToSave[props.sub_array] = formData.data;
        } else {
          dataToSave = formData.data;
        }
        if (props.collection_name !== "users")
          /* was seeing weird behavior editing the User table from System Admin screen...we can't overwrite the user if we are editing the user table Jan 17, 2025 */
          dataToSave["user"] =
            props.user; /* We now send the user record from the front end as of Aug 2, 2024 */
        const response = await fetchSecure(
          "/api/saveObject/" + config.collection,
          {
            headers: { "Content-Type": "application/json" },
            method: "post",
            //ORIG JUL 15, 2024body: JSON.stringify(formData.data)
            body: JSON.stringify(dataToSave),
          },
        );
        const data = await response.json();
        if (data.success) {
          formData.data["id"] =
            data.id; /* KAD added this to populate the primary key in the UI after saving for the first time */
          //console.log(data);
          setFormData({
            data: { ...formData.data },
            status: "SUCCESS",
          });
          setDisplayState("X");
          //console.log(JSON.stringify(formData));

          /* Go back and update the Tracking records */
          setTimeout(() => {
            loadObject(data.id);
          }, 1000);

          props.scrollToTop();
          setDisplayState("DISPLAY");
          setActionType("DISPLAY");
        } else {
          throw Error("Failed to add new " + config.name);
        }
      }
    } catch (e) {
      console.log(
        `Failed to add new ` + config.name + `: ${formData.data.agentType}`,
      );
      console.error(e);
      console.error(e.stack);
      setFormData({
        ...formData,
        status: "ERROR",
      });
    }
  };

  /* Vik (Jan 22, 2026): Removed actionsMemo - action buttons are now rendered directly in subHeaderComponentMemo
     to ensure proper left/right positioning (actions LEFT, filter RIGHT). */

  const actionsMemoTracking = useMemo(
    () => (
      <TrackingButtons
        displayState={displayState}
        props={props}
        createRecord={createRecord}
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  // Safely create theme only if style and theme are provided
  // Default to empty object if style is not provided
  const safeStyle = props.style || {};
  const safeTheme = safeStyle.theme || {};
  // Ensure customStyles is a valid object (not null, not undefined, not a function, not an array)
  // Also ensure it doesn't contain any functions that might cause issues
  let safeCustomStyles = {};
  if (
    safeStyle.customStyles &&
    typeof safeStyle.customStyles === "object" &&
    !Array.isArray(safeStyle.customStyles)
  ) {
    try {
      // Deep clone using JSON to remove any functions or circular references
      safeCustomStyles = JSON.parse(JSON.stringify(safeStyle.customStyles));
    } catch (e) {
      console.warn("Failed to clone customStyles:", e);
      safeCustomStyles = {};
    }
  }

  // Re-enable custom theme now that column selectors are fixed
  const useCustomTheme = true;

  // Track if theme was successfully created
  const [themeCreated, setThemeCreated] = useState(false);

  // Create theme only once when component mounts or theme changes
  useEffect(() => {
    if (
      useCustomTheme &&
      safeStyle.theme &&
      typeof safeStyle.theme === "object" &&
      Object.keys(safeStyle.theme).length > 0
    ) {
      try {
        // Ensure theme has the required structure
        const themeToUse = {
          text: safeStyle.theme.text || {},
          background: safeStyle.theme.background || {},
          context: safeStyle.theme.context || {},
          divider: safeStyle.theme.divider || {},
          action: safeStyle.theme.action || {},
        };
        createTheme("superappobject", themeToUse);
        setThemeCreated(true);
        console.log("✅ Custom theme 'superappobject' created successfully");
      } catch (e) {
        console.warn("⚠️ Failed to create theme:", e);
        setThemeCreated(false);
      }
    } else {
      setThemeCreated(false);
    }
  }, [useCustomTheme, safeStyle.theme]);

  // function showExport(field, formData) {}
  /*
          agent_type={formData.data.agentType}
          agent_name={formData.data.agentName}
  */

  /* Vik(Jul 14, 2025): Dynamically generate columns to handle file deletion spinner 
  Use dynamicColumns in DataTable components to apply spinner logic only in FILE_TABLE mode */
  const dynamicColumns = (columns || []).map((field) => {
    // Convert string-based selector to function (required for react-data-table-component v7+)
    const processedField = { ...field };

    // Handle function selectors stored as objects (e.g. { _functionString: "..." })
    if (
      field.selector &&
      typeof field.selector === "object" &&
      (field.selector._functionString || field.selector.__function__)
    ) {
      try {
        const funcStr =
          field.selector._functionString || field.selector.__function__;
        // eslint-disable-next-line no-eval
        processedField.selector = eval(`(${funcStr})`);
      } catch (e) {
        console.warn(
          "Failed to restore column selector function from object:",
          e,
        );
        processedField.selector = (row) => "";
      }
    }
    // Handle selectors that are strings but look like functions (e.g. "(row) => ...")
    // This happens if restoreFunctions wasn't called or failed but returned the string
    else if (
      typeof field.selector === "string" &&
      (field.selector.includes("=>") || field.selector.includes("function"))
    ) {
      try {
        // eslint-disable-next-line no-eval
        processedField.selector = eval(`(${field.selector})`);
      } catch (e) {
        console.warn(
          "Failed to restore column selector function from string:",
          e,
        );
        // Fallback to treating it as a property name if eval fails
        const propName = field.selector;
        processedField.selector = (row) => row[propName];
      }
    }
    // Handle simple string selectors (property names)
    else if (typeof field.selector === "string") {
      processedField.selector = (row) => row[field.selector];
    }
    // Handle missing selector but present name (fallback)
    else if (!field.selector && field.name) {
      processedField.selector = (row) => row[field.name];
    }

    if (field.button && displayState === "FILE_TABLE") {
      return {
        ...processedField,
        cell: (row) =>
          props.deletingFiles && props.deletingFiles[row.fileName] ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <MdDelete
              className="delete-icon"
              onClick={() =>
                window.confirm("Are you sure you wish to delete this file?") &&
                props.handleFileDelete(row.fileName)
              }
              id={row.fileName}
              size={30}
            />
          ),
      };
    }
    return processedField; /* Preserve original column definitions for non-button fields and other display states */
  });

  return (
    <>
      {displayState === "UPLOAD_ATTACHMENT" && (
        <UploadFileNew
          filePrefix={collection_name
            .concat("~~")
            .concat(formData.data.id)
            .concat("~~")}
          collectionName={collection_name}
          id={formData.data.id}
          userId={formData.data.user}
          callback={callbackForUploadFile}
          handleUploadFileCancel={callbackForCancelUploadFile}
          formData={formData.data}
          uploadConfig={config.uploadConfig}
        />
      )}
      {displayState === "UPLOAD_FILE_FOR_IMPORT" && (
        <UploadFileForImport
          collectionName={collection_name}
          userId={props.user}
          callback={callbackForUploadFileForImport}
          handleUploadFileCancel={callbackForCancelUploadFileForImport}
        />
      )}
      {displayState === "TRACKING_TABLE" && (
        <div
          style={{
            fontSize: "14px",
            marginLeft: "-15px",
            marginRight: "-15px",
            borderRadius: "10px",
          }}
        >
          <div
            className="common-from-sub-heading"
            onClick={() => setShowTrackingList(!showTrackingList)}
          >
            <div className="leinfo">Tracking List</div>
            <button
              type="button"
              className={showTrackingList ? "accord-btn active" : "accord-btn"}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-chevron-down"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                />
              </svg>
            </button>
          </div>

          {showTrackingList && (
            <DataTable
              title=""
              columns={dynamicColumns}
              data={filteredItems}
              noContextMenu
              noHeader
              paginationResetDefaultPage={resetPaginationToggle}
              highlightOnHover
              striped
              dense
              persistTableHead
              defaultSortFieldId={sortData.selector}
              defaultSortAsc="true"
              onRowClicked={props.onRowClick}
              customStyles={safeCustomStyles}
              actions={actionsMemoTracking}
              theme={themeCreated ? "superappobject" : undefined}
            />
          )}
        </div>
      )}
      {displayState === "FILE_TABLE" && (
        <div
          style={{
            fontSize: "14px",
            marginLeft: "-15px",
            marginRight: "-15px",
            cursor: "default",
            borderRadius: "10px",
          }}
        >
          <DataTable
            title=""
            columns={dynamicColumns}
            data={filteredItems}
            noContextMenu
            noHeader
            paginationResetDefaultPage={resetPaginationToggle}
            highlightOnHover
            striped
            dense
            persistTableHead
            defaultSortFieldId={sortData.selector}
            defaultSortAsc="true"
            onRowClicked={handleFileClicked}
            customStyles={safeCustomStyles}
            actions={actionsMemoTracking}
            theme={themeCreated ? "superappobject" : undefined}
          />
        </div>
      )}
      {displayState === "BASIC_TABLE" && (
        <>
          <DataTable
            title={props?.title}
            columns={dynamicColumns}
            data={filteredItems}
            noContextMenu
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            highlightOnHover
            striped
            dense
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            persistTableHead
            defaultSortFieldId={sortData.selector}
            defaultSortAsc={sortData.asc}
            onRowClicked={props.onRowClick}
            customStyles={safeCustomStyles}
            paginationPerPage={
              config?.otherTableOptions?.paginationPerPage || 10
            }
            theme={themeCreated ? "superappobject" : undefined}
          />
        </>
      )}
      {/* Vik (Jan 22, 2026): Removed actions={actionsMemo} from BASIC_TABLE - actions now in subHeaderComponent */}
      {displayState === "STATS_TABLE" && (
        <>
          <DataTable
            title={props?.title}
            columns={dynamicColumns}
            data={filteredItems}
            noContextMenu
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            highlightOnHover
            striped
            dense
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            selectableRows
            persistTableHead
            onSelectedRowsChange={handleSelectChange}
            defaultSortFieldId={sortData.selector}
            defaultSortAsc={sortData.asc}
            onRowClicked={handleRowClicked}
            customStyles={safeCustomStyles}
            paginationPerPage={
              config?.otherTableOptions?.paginationPerPage || 10
            }
            theme={themeCreated ? "superappobject" : undefined}
          />
        </>
      )}
      {displayState === "TABLE" && (
        <>
          <DataTable
            title={props.title}
            columns={dynamicColumns}
            data={filteredItems}
            noContextMenu
            pagination
            paginationResetDefaultPage={resetPaginationToggle}
            highlightOnHover
            striped
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            selectableRows
            persistTableHead
            onSelectedRowsChange={handleSelectChange}
            defaultSortFieldId={sortData.selector}
            defaultSortAsc={sortData.asc}
            onRowClicked={handleRowClicked}
            customStyles={safeCustomStyles}
            paginationPerPage={
              config?.otherTableOptions?.paginationPerPage || 10
            }
            theme={themeCreated ? "superappobject" : undefined}
          />
        </>
      )}
      {/* Vik (Jan 22, 2026): Removed actions={actionsMemo} from TABLE - actions now in subHeaderComponent */}
      {displayState === "DRILL" && (
        <>
          <div>
            <SuperAppButton onClick={(e) => backToBASIC()}>Back</SuperAppButton>
          </div>
          <SuperAppObject
            depth={props.depth + 1}
            style={props.style}
            title={props.drill_title}
            config={props.drill_config}
            user={props.user}
            userDeep={props.userDeep}
            collection_name={props.drill_collection}
            drill_where_field="NAICS Code"
            drill_where_value={whereValue}
            displayState="BASIC_TABLE"
            onRowClick={handleRowClickedDisplay}
          />
        </>
      )}
      {displayState === "CREATE_EDIT" && (
        <CreateEditNew
          config={config}
          allObjects={props.allObjects ?? data}
          thisObject={formData.data}
          actionType={actionType}
          setDisplayState={setDisplayState}
          setActionType={setActionType}
          loadObject={loadObject}
          loadObjects={loadObjects}
          originalData={originalData}
          style={props.style}
          scrollToTop={props.scrollToTop}
          user={props.user}
          userDeep={props.userDeep}
          setFormData={setFormData}
          topLevelSave={props.topLevelSave}
          depth={props.depth}
          subTable={props.subTable}
          inputData={props.inputData}
          dontPersistData={props.dontPersistData}
          submit={props.submit}
          hideBackButton={props.hideBackButton || false}
          hideTrackingList={props.hideTrackingList || false}
          activeTab={activeTab}
          dynamicDisplayComponent={props.dynamicDisplayComponent}
        />
      )}
      {/* KAD added donPersistData to DisplayDetails so I can remove buttons like Refresh or toggle the behavior of the Delete button for Config Editor type usecases Feb 12, 2025 */}
      {displayState === "DISPLAY" &&
        formData.data &&
        Object.keys(formData.data).length !== 0 && (
          <DisplayDetailsNew
            config={config}
            allObjects={props.allObjects ?? data}
            thisObject={formData.data}
            setDisplayState={setDisplayState}
            setActionType={setActionType}
            loadObjects={loadObjects}
            loadObject={loadObject}
            originalData={originalData}
            style={props.style}
            scrollToTop={props.scrollToTop}
            user={props.user}
            setFormData={setFormData}
            deepConfig={deepConfig}
            callBackForUploadFile={callbackForUploadFile}
            showAgent={props.showAgent}
            canEdit={props.canEdit}
            dynamicDisplayButtons={props.dynamicDisplayButtons}
            depth={props.depth}
            subTable={props.subTable}
            topLevelSave={topLevelSave}
            userDeep={props.userDeep}
            dontPersistData={props.dontPersistData}
            setActiveTab={setActiveTab}
            hideBackButton={props.hideBackButton || false}
            hideTrackingList={props.hideTrackingList || false}
            activeTab={activeTab}
          />
        )}
    </>
  );
}
